import { useGame } from "./GameContext";

const HINTS = [
  "기억의 조각 #1",
  "기억의 조각 #2",
  "기억의 조각 #3",
  "기억의 조각 #4",
  "기억의 조각 #5",
  "기억의 조각 #6",
  "기억의 조각 #7",
  "기억의 조각 #8",
  "기억의 조각 #9",
  "기억의 조각 #10",
  "기억의 조각 #11",
  "기억의 조각 #12",
  "기억의 조각 #13",
  "기억의 조각 #14",
  "의뢰인의 정보",
];

export default function HintList() {
  const { clearedStages, openHintDetail } = useGame();

  return (
    <div className="box_con con_box_storage con_box_storage01">
      <div className="box_con con_pd6">
        <p className="storage_tit mb8">기억 보관 상자</p>
        <p className="storage_txt mb40">기억의 조각을 모두 수집하세요.</p>

        <div className="storage_pBox">
          {HINTS.map((txt, idx) => {
            const stageKey = `q${idx + 1}`;
            const isUnlocked = clearedStages.has(stageKey);

            return (
              <a
                key={idx}
                className={`mb16 storage_ck storage_${idx + 1} ${
                  isUnlocked ? "sel" : ""
                }`}
                onClick={() => {
                  if (!isUnlocked) return;
                  openHintDetail(idx);
                }}
              >
                {txt}
              </a>
            );
          })}
        </div>
      </div>
    </div>
  );
}
